import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            探索六大分类
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            从角色分析到收藏指南，全方位覆盖火影同人文化的每个角落
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center justify-between">
                <span className="text-xs text-foreground-400">
                  {cat.articleCount} 篇文章
                </span>
                <span className="text-xs text-primary-500 font-medium opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
                  浏览分类
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}